// frontend/src/pages/CommonQuestionsPage.js
import { useTranslation } from "react-i18next";

export default function CommonQuestionsPage() {
  const { t } = useTranslation();

  // 定義常見問題陣列，裡面每一項僅存放 i18n key
  const faqs = [
    {
      question: "faqs.commonQuestions.q1.question", // i18n key
      answer: "faqs.commonQuestions.q1.answer",
    },
    {
      question: "faqs.commonQuestions.q2.question",
      answer: "faqs.commonQuestions.q2.answer",
    },
    {
      question: "faqs.commonQuestions.q3.question",
      answer: "faqs.commonQuestions.q3.answer",
    },
    {
      question: "faqs.commonQuestions.q4.question",
      answer: "faqs.commonQuestions.q4.answer",
    },
    {
      question: "faqs.commonQuestions.q5.question",
      answer: "faqs.commonQuestions.q5.answer",
    },
  ];

  return (
    <div className="container mx-auto px-6 py-12">
      <h1 className="text-4xl font-bold text-center mb-8">
        {t("faqs.commonQuestions.title")} {/* 可於翻譯檔定義標題 */}
      </h1>
      <div className="space-y-6">
        {faqs.map((faq, index) => (
          <div
            key={index}
            className="border border-gray-300 dark:border-gray-700 rounded-lg p-4"
          >
            <h3 className="font-semibold text-xl">{t(faq.question)}</h3>
            <p className="mt-2 text-gray-600 dark:text-gray-400">
              {t(faq.answer)}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
